<template>

    <div class="languages">

        <p class="languages-title" :style="{ color: color }" v-if="hidding('title')">
            Annual<br>
            Report
            <span>2019</span>
        </p>

        <div class="languages-list" v-if="hidding('list')">
            <a :href="$root.base_url + 'fr' + url" class="languages-item" :style="{ color: color }">FR</a>
            <a :href="$root.base_url + 'en' + url" class="languages-item active" :style="{ color: color }">EN</a>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Languages",
        props: ['color', 'hide'],
        computed: {
            url() {
                return this.$route.path;
            }
        },
        methods: {
            hidding(div) {
                if (div === this.hide && window.innerWidth <= 780)
                    return false;

                return true;
            }
        }
    }
</script>

<style scoped lang="scss">

    .languages {

        &-title {
            text-align: right;
            font-weight: 900;
            text-transform: uppercase;

            span {
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;
                font-weight: 300;

                &::before {
                    content: '';
                    width: 20px;
                    height: 1px;
                    background-color: currentColor;
                    display: flex;
                    position: relative;
                    top: -5px;
                    margin-right: 8px;
                }

            }

        }

        &-list {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
        }

        &-item {
            font-size: 14px;
            text-decoration: none;
            margin-right: 20px;
            transition: .25s ease;

            &:hover {
                color: #a1bf38 !important;
            }

            &:last-child {
                margin-right: 0;
            }

            &.active {
                font-weight: 900;
                text-decoration: underline;
            }

        }
    }

    @media screen and (max-width: 780px) {
        .languages {
            &-title {
                text-align: left;
                font-size: 12px;

                span {
                    flex-direction: row-reverse;

                    &::before {
                        margin-left: 14px;
                        margin-right: 0;
                        width: 25px;
                    }

                }
            }
        }
    }

</style>
